import React from 'react'
import { Outlet } from 'react-router-dom'

function MainQuotes() {
  return (
    <div>
      <Outlet/>
    </div>
  )
}

export default MainQuotes
